import type { ErrorSummary } from '@pa/api/clinic'

/** "N in the last 24 h" · "N in the last 7 days" (UserFlows C-03): `error_events` rows; filters don't change them. */
export function ErrorCounters({ summary }: { summary: ErrorSummary | undefined }) {
  return (
    <div className="actions err-counts" aria-live="polite">
      <span>
        <b>{summary?.last24h ?? '–'}</b> in the last 24 h
      </span>
      <span>
        <b>{summary?.last7d ?? '–'}</b> in the last 7 days
      </span>
    </div>
  )
}
